window.installPromoPopupData = function () {
  var API_PATH = '/website/installFee/shopify/calculate';

  // API price query SKUs (match backend / fee API)
  var API_SKU_MAP = {
    'shp2_with':    'EFC-InstallpermitSHP2-US',
    'shp2_without': 'EFC-Install-US',
    'shp3_with':    'EFC-InstallpermitSHP3-US',
    'shp3_without': 'EFC-InstallSHP3-US',
    'gateway_with': 'EFC-InstallpermitATS-US',
    'gateway_without':'EFC-InstallATS-US',
  };

  // Shopify cart SKUs (match turnkey-installation-service-new product variants)
  var CART_SKU_MAP = {
    'shp2_with':    'EFC-InstallpermitSHP2-US',
    'shp2_without': 'EFC-Install-US',
    'shp3_with':    'EFC-InstallpermitSHP3-US',
    'shp3_without': 'EFC-InstallSHP3-US',
    'gateway_with': 'EFC-InstallpermitATS-US',
    'gateway_without':'EFC-InstallATS-US',
  };

  return {
    isOpen: false,
    installType: '',
    installTypeOpen: false,
    permit: '',
    permitOpen: false,
    zipCode: '',
    showPriceRow: false,
    calculatedPrice: 0,
    isLoading: false,
    errorMessage: '',

    installTypes: [
      { id: 'shp2', label: 'Smart Home Panel 2' },
      { id: 'shp3', label: 'Smart Home Panel 3' },
      { id: 'gateway', label: 'Smart Gateway (200A)' },
    ],

    permitOptions: [
      { id: 'with', label: 'With Permit' },
      { id: 'without', label: 'Without Permit' },
    ],

    get installTypeLabel() {
      return this.installTypes.find(function (t) { return t.id === this.installType; }.bind(this))?.label || '';
    },

    get permitLabel() {
      return this.permitOptions.find(function (p) { return p.id === this.permit; }.bind(this))?.label || '';
    },

    getSkuKey() {
      return this.installType + '_' + this.permit;
    },

    hidePriceRow() {
      this.showPriceRow = false;
      this.calculatedPrice = 0;
      this.errorMessage = '';
    },

    onVariantChange(event) {
      var variantId = event?.detail?.variant?.id;
      if (!variantId) return;

      document.querySelectorAll('.install-promo-block[data-product-variant]').forEach(function (el) {
        var match = parseInt(el.dataset.productVariant, 10) === parseInt(variantId, 10);
        el.classList.toggle('show', match);
      });

      this.closeModal();
      this.hidePriceRow();
    },

    openModal() {
      var visiblePromo = document.querySelector('.install-promo-block[data-product-variant].show');
      if (!visiblePromo || visiblePromo.classList.contains('disabled')) return;

      this.isOpen = true;
      document.documentElement.classList.add('install-promo-modal-open');
    },

    closeModal() {
      this.isOpen = false;
      this.installTypeOpen = false;
      this.permitOpen = false;
      document.documentElement.classList.remove('install-promo-modal-open');
    },

    closeAllDropdowns() {
      this.installTypeOpen = false;
      this.permitOpen = false;
    },

    toggleInstallType() {
      var next = !this.installTypeOpen;
      this.closeAllDropdowns();
      this.installTypeOpen = next;
    },

    togglePermit() {
      var next = !this.permitOpen;
      this.closeAllDropdowns();
      this.permitOpen = next;
    },

    selectInstallType(id) {
      this.installType = id;
      this.installTypeOpen = false;
      this.hidePriceRow();
    },

    selectPermit(id) {
      this.permit = id;
      this.permitOpen = false;
      this.hidePriceRow();
    },

    async checkZip() {
      if (this.isLoading) return;

      this.errorMessage = '';
      this.showPriceRow = false;

      if (!this.installType) {
        this.errorMessage = 'Please select an installation type.';
        return;
      }
      if (!this.permit) {
        this.errorMessage = 'Please select a permit option.';
        return;
      }

      var zip = this.zipCode.replace(/\D/g, '');
      if (zip.length < 5) {
        this.errorMessage = 'Please enter a valid 5-digit ZIP code.';
        return;
      }
      this.zipCode = zip.slice(0, 5);

      var sku = API_SKU_MAP[this.getSkuKey()];
      if (!sku) {
        this.errorMessage = 'Invalid combination selected.';
        return;
      }

      var root = this.$root;
      var apiDomain = root.dataset.apiDomain || '';
      var xAppid = root.dataset.xAppid || '';

      if (!apiDomain) {
        this.errorMessage = 'API configuration is missing.';
        return;
      }

      this.isLoading = true;
      try {
        var response = await fetch(apiDomain + API_PATH, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-APPID': xAppid,
          },
          body: JSON.stringify({ sku: sku, zipCode: this.zipCode }),
        });

        var result = await response.json();

        if (result.code === '0' && result.data) {
          this.calculatedPrice = result.data.totalFee;
          this.showPriceRow = true;
        } else if (result.code === '50215') {
          this.errorMessage = 'Sorry, this ZIP code is out of service area.';
        } else if (result.code === '50214') {
          this.errorMessage = 'The selected service is not available.';
        } else if (result.code === '1001') {
          this.errorMessage = 'Server is busy. Please try again later.';
        } else {
          this.errorMessage = result.message || 'Something went wrong. Please try again.';
        }
      } catch (e) {
        this.errorMessage = 'Network error. Please check your connection and try again.';
      } finally {
        this.isLoading = false;
      }
    },

    async findVariantBySku(cartSku) {
      var root = this.$root;
      var skuVariantMap = {};
      try {
        skuVariantMap = JSON.parse(root.dataset.skuVariantMap || '{}');
      } catch (e) {}

      if (skuVariantMap[cartSku]) return skuVariantMap[cartSku];

      var handle = root.dataset.installProductHandle || 'turnkey-installation-service-new';
      try {
        var pRes = await fetch('/products/' + handle + '.js');
        if (pRes.ok) {
          var pData = await pRes.json();
          var variants = pData.variants || [];
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].sku === cartSku) return variants[i].id;
          }
        }
      } catch (e) {}

      return null;
    },

    async addToCart() {
      if (!this.showPriceRow || this.isLoading) return;

      var cartSku = CART_SKU_MAP[this.getSkuKey()];
      if (!cartSku) return;

      this.isLoading = true;
      this.errorMessage = '';

      try {
        var variantId = await this.findVariantBySku(cartSku);
        if (!variantId) {
          this.errorMessage = 'Installation service variant not found.';
          return;
        }

        var response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                '_zipCode': this.zipCode,
                '_installFee': this.calculatedPrice,
              },
            }],
          }),
        });

        if (!response.ok) throw new Error('Cart request failed');

        this.closeModal();
        if (typeof theme !== 'undefined' && theme.Cart && theme.Cart.prototype._onProductAdded) {
          setTimeout(function () { theme.Cart.prototype._onProductAdded(); }, 500);
        }
      } catch (e) {
        if (!this.errorMessage) {
          this.errorMessage = 'Failed to add to cart. Please try again.';
        }
      } finally {
        this.isLoading = false;
      }
    },
  };
};
